import { createSlice } from "@reduxjs/toolkit";
import {
  getDonationsDetails,
  getHealthStates,
  getPaymentDetails,
  getSponsorDisbursements,
  getAllSponsorRequests,
  getRequestsTypes,
  getSponsorDetails,
  getSponsorPaymentReport,
  getSponsorReports,
  getSponsorshipAmounts,
  getSponsorThanksCertificate,
  getUnsponsoredOrphans,
  toAddSponsor,
  addRequest,
  toGetAllBanks,
  toGetAllContactMethods,
  toGetAllContactTime,
  toAddBooking,
  getAllSponsorBooking,
  getSponsoredOrphans,
  getEndowment,
  getEndowmentTypes,
  getSponsoredOrphansWithPagination,
  getOrphansNeeds,
  getMyOrphansNeeds,
} from "../actions/sponsor.actions";

/* Intiatlisation of initialeState */
const initialState = {
  sponsor: {} as any,
  contact_methods: [] as any,
  contact_time: [] as any,
  banks: [] as any,
  sponsorReports: [] as any,
  color: {} as any,
  certificateThanks: null as any,
  report: null as any,
  loading: false as boolean,
  error: null as unknown | null,
  sponsorDetails: [] as any,
  payments: [] as any,
  donations: [] as any,
  unsponsoredOrphans: [] as any,
  TotalPages: 0 as number,
  TotalPayments: 0 as number,
  disbursements: [] as any,
  TotalDisbursements: 0 as number,
  TotalDonations: 0 as number,
  TotalReports: 0 as number,
  TotalUnsponsored: 0 as number,
  healthStates: [] as any,
  sponsorshipAmount: [] as any,
  requestsTypes: [] as any,
  requests: [] as any,
  sponsorRequest: {} as any,
  sponsoredOrphans: [] as any,
  sponsoredWithPagination: [] as any,
  TotalSponsoredWithPagination: 0 as number,
  booking: {
    data: {} as any,
    isLoading: false as boolean,
    error: null as any,
  } as any,
  sponsorBooking: [] as any,
  endowment: [] as any,
  endowmentTypes: [] as any,
  orphansNeeds: [] as any,
  TotalOrphansNeeds: 0 as number,
  myOrphansNeeds: [] as any,
  TotalMyOrphansNeeds: 0 as number,
};

/* Sponsor slice configuration */
export const sponsorSlice = createSlice({
  name: "sponsor",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    /* Add sponsor */
    builder.addCase(toAddSponsor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toAddSponsor.fulfilled, (state, action) => {
      state.sponsor = action.payload;
      state.loading = false;
    });
    builder.addCase(toAddSponsor.rejected, (state, action) => {
      state.sponsor = {};
      state.loading = false;
      state.error = action.payload;
    });
    /* get all contact methods */
    builder.addCase(toGetAllContactMethods.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toGetAllContactMethods.fulfilled, (state, action) => {
      state.contact_methods = action.payload.data;
      state.loading = false;
    });
    builder.addCase(toGetAllContactMethods.rejected, (state, action) => {
      state.contact_methods = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all contact time */
    builder.addCase(toGetAllContactTime.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toGetAllContactTime.fulfilled, (state, action) => {
      state.contact_time = action.payload.data;
      state.loading = false;
    });
    builder.addCase(toGetAllContactTime.rejected, (state, action) => {
      state.contact_time = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get all banks */
    builder.addCase(toGetAllBanks.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toGetAllBanks.fulfilled, (state, action) => {
      state.banks = action.payload.data;
      state.loading = false;
    });
    builder.addCase(toGetAllBanks.rejected, (state, action) => {
      state.banks = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* get sponsor details */
    builder.addCase(getSponsorDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSponsorDetails.fulfilled, (state, action) => {
      state.sponsorDetails = action.payload;
      state.loading = false;
    });
    builder.addCase(getSponsorDetails.rejected, (state, action) => {
      state.sponsorDetails = [];
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getSponsorReports.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSponsorReports.fulfilled, (state, action) => {
      state.color = action?.payload?.color;
      state.sponsorReports = action?.payload?.data?.reports;
      state.TotalReports = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getSponsorReports.rejected, (state, action) => {
      state.color = {};
      state.TotalReports = 0;
      state.sponsorReports = [];
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getSponsorThanksCertificate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSponsorThanksCertificate.fulfilled, (state, action) => {
      state.certificateThanks = action?.payload?.data;
      state.loading = false;
    });
    builder.addCase(getSponsorThanksCertificate.rejected, (state, action) => {
      state.certificateThanks = {};
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getSponsorPaymentReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSponsorPaymentReport.fulfilled, (state, action) => {
      state.report = action?.payload?.data;

      state.loading = false;
    });
    builder.addCase(getSponsorPaymentReport.rejected, (state, action) => {
      state.report = {};
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getDonationsDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDonationsDetails.fulfilled, (state, action) => {
      state.donations = action?.payload?.data;
      state.TotalDonations = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getDonationsDetails.rejected, (state, action) => {
      state.TotalDonations = 0;
      state.donations = [];
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getPaymentDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPaymentDetails.fulfilled, (state, action) => {
      state.payments = action?.payload?.data;
      state.TotalPayments = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getPaymentDetails.rejected, (state, action) => {
      state.TotalPayments = 0;
      state.payments = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* get sponsor disbursements */
    builder.addCase(getSponsorDisbursements.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSponsorDisbursements.fulfilled, (state, action) => {
      state.disbursements = action?.payload?.data;
      state.TotalDisbursements = action?.payload?.total_pages;
      state.loading = false;
    });
    builder.addCase(getSponsorDisbursements.rejected, (state, action) => {
      state.TotalDisbursements = 0;
      state.disbursements = [];
      state.loading = false;
      state.error = action.payload;
    });

    /* get Unsponsored Orphans */
    builder.addCase(getUnsponsoredOrphans.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUnsponsoredOrphans.fulfilled, (state, action) => {
      state.unsponsoredOrphans = action.payload.data;
      state.TotalUnsponsored = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getUnsponsoredOrphans.rejected, (state, action) => {
      state.unsponsoredOrphans = [];
      state.TotalUnsponsored = 0;
      state.loading = false;
      state.error = action.payload;
    });
    /* get health states */
    builder.addCase(getHealthStates.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHealthStates.fulfilled, (state, action) => {
      state.healthStates = action.payload;
      state.loading = false;
    });
    builder.addCase(getHealthStates.rejected, (state, action) => {
      state.healthStates = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* get */
    builder.addCase(getSponsorshipAmounts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSponsorshipAmounts.fulfilled, (state, action) => {
      state.sponsorshipAmount = action.payload;
      state.loading = false;
    });
    builder.addCase(getSponsorshipAmounts.rejected, (state, action) => {
      state.sponsorshipAmount = [];
      state.loading = false;
      state.error = action.payload;
    });
    //Requests Types
    builder.addCase(getRequestsTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRequestsTypes.fulfilled, (state, action) => {
      state.requestsTypes = action?.payload;
      state.loading = false;
    });
    builder.addCase(getRequestsTypes.rejected, (state, action) => {
      state.requestsTypes = [];
      state.loading = false;
      state.error = action.payload;
    });
    //All Sponsor Requests
    builder.addCase(getAllSponsorRequests.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllSponsorRequests.fulfilled, (state, action) => {
      state.requests = action?.payload?.data;
      state.loading = false;
    });
    builder.addCase(getAllSponsorRequests.rejected, (state, action) => {
      state.requests = [];
      state.loading = false;
      state.error = action.payload;
    });
    //Add Sponsor Request
    builder.addCase(addRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addRequest.fulfilled, (state, action) => {
      state.sponsorRequest = action?.payload;
      state.loading = false;
    });
    builder.addCase(addRequest.rejected, (state, action) => {
      state.sponsorRequest = {};
      state.loading = false;
      state.error = action.payload;
    });
    /*------------------ADD BOOKING------------------ */
    builder.addCase(toAddBooking.pending, (state) => {
      state.booking.loading = true;
    });
    builder.addCase(toAddBooking.fulfilled, (state, action) => {
      state.booking.data = action.payload;
      state.booking.loading = false;
    });
    builder.addCase(toAddBooking.rejected, (state, action) => {
      state.booking.data = {};
      state.booking.loading = false;
      state.booking.error = action.payload;
    });

    builder.addCase(getAllSponsorBooking.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllSponsorBooking.fulfilled, (state, action) => {
      state.sponsorBooking = action?.payload;
      state.loading = false;
    });
    builder.addCase(getAllSponsorBooking.rejected, (state, action) => {
      state.sponsorBooking = {};
      state.loading = false;
      state.error = action.payload;
    });
    /* get Sponsored Orphans */
    builder.addCase(getSponsoredOrphans.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSponsoredOrphans.fulfilled, (state, action) => {
      state.sponsoredOrphans = action.payload.data;
      state.TotalPages = action.payload.total_pages;

      state.loading = false;
    });
    builder.addCase(getSponsoredOrphans.rejected, (state, action) => {
      state.sponsoredOrphans = [];
      state.TotalPages = 0;
      state.loading = false;
      state.error = action.payload;
    });
    /* get Endowments */
    builder.addCase(getEndowment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEndowment.fulfilled, (state, action) => {
      state.endowment = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getEndowment.rejected, (state, action) => {
      state.endowment = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* get Endowment Types */
    builder.addCase(getEndowmentTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEndowmentTypes.fulfilled, (state, action) => {
      state.endowmentTypes = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getEndowmentTypes.rejected, (state, action) => {
      state.endowmentTypes = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* get Sponsored Orphans with pagination*/
    builder.addCase(getSponsoredOrphansWithPagination.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getSponsoredOrphansWithPagination.fulfilled,
      (state, action) => {
        state.sponsoredWithPagination = action.payload.data;
        state.TotalSponsoredWithPagination = action.payload.total_pages;

        state.loading = false;
      }
    );
    builder.addCase(
      getSponsoredOrphansWithPagination.rejected,
      (state, action) => {
        state.sponsoredWithPagination = [];
        state.TotalSponsoredWithPagination = 0;
        state.loading = false;
        state.error = action.payload;
      }
    );

    /////// get orphans needs //////////////
    builder.addCase(getOrphansNeeds.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOrphansNeeds.fulfilled, (state, action) => {
      state.orphansNeeds = action?.payload?.data;
      state.TotalOrphansNeeds = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getOrphansNeeds.rejected, (state, action) => {
      state.TotalOrphansNeeds = 0;
      state.orphansNeeds = [];
      state.loading = false;
      state.error = action.payload;
    });
    /////// get my orphans needs //////////////
    builder.addCase(getMyOrphansNeeds.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMyOrphansNeeds.fulfilled, (state, action) => {
      state.myOrphansNeeds = action?.payload?.data;
      state.TotalMyOrphansNeeds = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getMyOrphansNeeds.rejected, (state, action) => {
      state.TotalMyOrphansNeeds = 0;
      state.myOrphansNeeds = [];
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default sponsorSlice.reducer;
